(() => {
  const init = () => {
    if (typeof window.lottie === 'undefined') return;

    document.querySelectorAll('.streamspell-sidebar__menu-icon[data-lottie-icon]').forEach((node) => {
      if (node.dataset.lottieReady === 'true') return;
      const path = node.dataset.lottiePath;
      if (!path) return;

      const anim = window.lottie.loadAnimation({
        container: node,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path
      });

      anim.addEventListener('DOMLoaded', () => {
        anim.goToAndStop(0, true);
      });

      const owner = node.closest('.streamspell-sidebar__menu-link') || node.parentElement;
      if (owner) {
        owner.addEventListener('mouseenter', () => {
          anim.stop();
          anim.play();
        });

        owner.addEventListener('mouseleave', () => {
          anim.goToAndStop(0, true);
        });
      }

      node.dataset.lottieReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
